import DOMPurify from "dompurify";

/**
 * DOMPurifyを使用してHTML文字列をサニタイズする。
 * dangerouslySetInnerHTMLやdangerouslyPasteHTMLに渡す前に必ず使用すること。
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, { USE_PROFILES: { html: true } });
}
